import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";

const HAIRCOLOR_PROGRESS_STEPS = [
  { threshold: 10, label: "Analyzing undertone and skin warmth" },
  { threshold: 35, label: "Measuring contrast and depth levels" },
  { threshold: 60, label: "Checking harmony with natural hair depth" },
  { threshold: 85, label: "Comparing flattering shade directions" },
  { threshold: 100, label: "Selecting your best haircolor range" },
];

const FaceMeshHaircolorV2Page = () => (
  <FaceMeshAsyncV2Page
    analyticsPrefix="facemesh_haircolor_v2"
    continueUrl="/haircolor-3month-29"
    missingImageHelpPath="/facemesh-haircolor-v2"
    pagePath="/facemesh-haircolor-v2"
    progressSteps={HAIRCOLOR_PROGRESS_STEPS}
  />
);

export default FaceMeshHaircolorV2Page;
